import { ComputedStaticTextInput } from '@framework/form/inputs/computed/ComputedStaticTextInput.tsx';
import { DateTime } from 'luxon';
import { useCallback } from 'react';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type IComputedDateWidget } from '../IComputedWidget.ts';

type IComputedDateWidgetComponentProps =
  IWidgetComponentProps<IComputedDateWidget>;

export function ComputedDateWidgetComponent(
  props: IComputedDateWidgetComponentProps,
) {
  const { widget } = props;

  const options = getWidgetProps(props);

  const formatValue = useCallback(
    (value: string | null) =>
      value
        ? DateTime.fromFormat(value, 'yyyy-MM-dd').toFormat('dd/MM/yyyy')
        : '',
    [],
  );
  return (
    <ConfigFormItem
      hidden={widget.layout?.hide}
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options?.helpText ? (
          <RichTextAdvancedRender inline text={options?.helpText} />
        ) : undefined
      }
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      <ComputedStaticTextInput
        name={options.name}
        removeBorder={widget.layout?.removeBorder}
        format={formatValue}
      />
    </ConfigFormItem>
  );
}
